import jwt from 'jwt-decode';
import storage from '@lagersoft/key-storage';

export const getToken = (key = 'tokenIvr') => {
  const token = storage.get(key);

  if (token) {
    return jwt(token);
  }

  return null;
};

export const setToken = (key = 'tokenIvr', token) => {
  if (token) {
    storage.set(key, token);
  }
};
